<template>
	<Layout>
		<div class="wrap">
			<b class="clf">개인정보처리방침</b>
			<small class="date">2022.11.28</small>
			<h3>더조인 개인정보처리방침</h3>

			<p>
				㈜더조인(이하 ‘회사’)은 "정보통신망
				이용촉진 및 정보보호 등에 관한 법률"(이하
				'정보통신망법') 및 관계 법령의
				개인정보보호규정 등을 준수함으로써
				이용자의 개인정보 보호를 위한 조치를
				취하고 있습니다.<br />
				<br />
				<b
					>1. 수집하는 개인정보의 항목 및
					수집방법</b
				><br />
				① 회사는 이용자의 서비스 이용 시, 아래와
				같은 이용자의 개인정보들이 수집될 수
				있습니다.<br />
				o 수집방법 : 모바일, 전자우편, 서면,
				전화<br />
				o 수집항목 : ID, 비밀번호, 실명, 닉네임,
				성별, 휴대전화번호, 키, 체중, 통신사 정보,
				암호화된 동일인 식별정보(CI),
				중복가입확인정보(DI), 내외국인 구분,
				단말기 정보(모델명, OS 종류 및 버전), 앱
				이용 및 접속기록, 인증기록, 대금결제기록,
				접속일시기록, 불량이용기록, 디바이스 연동
				측정정보, 제공된 콘텐츠의 수동기록 정보<br />
				<br />
				<b>2. 개인정보의 수집 및 이용목적</b
				><br />
				회사가 수집한 개인정보의 수집•이용목적은
				다음과 같습니다.<br />
				① 회원의 관리<br />
				서비스 이용에 따른 본인식별 : 이름,
				생년월일, 성별, 휴대폰번호, 통신사,
				내외국인, 암호화된 동일인 식별정보(CI),
				중복가입확인정보(DI)<br />
				불만처리 등 민원처리 : ID, 전자우편주소,
				휴대전화번호, 이름, 디바이스 연동
				측정정보, 제공된 콘텐츠의 수동기록정보<br />
				② 서비스 제공에 관한 계약의 이행 및 서비스
				제공에 따른 요금의 정산<br />
				콘텐츠 제공 : ID, 비밀번호, 닉네임, 성별,
				프로필사진, 전자우편주소, 이름,
				휴대전화번호, 통신사 정보, 단말기
				정보(모델명, OS 종류 및 버전), 앱 이용 및
				접속기록, 인증기록, 대금결제기록,
				접속일시기록, 불량이용기록<br />
				유료정보 이용 및 요금결제 :
				대금결제기록<br />
				③ 이벤트 및 마케팅에의 활용<br />
				이벤트 진행 : 이름, 전자우편주소,
				휴대전화번호, 주소<br />
				마케팅 진행 : 통신사정보, 단말기 정보, 앱
				이용 및 접속기록, 불량이용기록<br />
				<br />
				<b>3. 개인정보의 보유 및 이용기간</b
				><br />
				① 이용자의 개인정보는 원칙적으로 계정삭제
				시 또는 개인정보 수집 및 이용목적 달성 시
				지체 없이 파기합니다. 단, 관계법령의
				규정에 의하여 보존할 필요가 있는 경우
				회사는 관계법령에서 정한 일정한 기간동안
				회원정보를 보관합니다.<br />
				<br />
				<b>4. 개인정보의 파기 절차 및 방법</b
				><br />
				1. 회사는 원칙적으로 개인정보 수집 및
				이용목적이 달성된 후에는 해당 정보를 지체
				없이 파기합니다. 파기절차 및 방법은 다음과
				같습니다.<br />
				o 파기절차<br />
				§ 회사는 보존 근거에 따라 보존 기간 동안
				개인정보를 보관 한 후, 재생이 불가능한
				방법으로 파기합니다.<br />
				o 파기방법<br />
				1) 전자적 파일형태로 저장된 개인정보는
				기록을 재생할 수 없는 기술적 방법을
				사용하여 삭제합니다.<br />
				2) 종이에 출력된 개인정보는 분쇄기로
				분쇄하여 파기합니다.<br />
				<br />
				<b>5. 개인정보 제공 및 공유</b><br />
				① 회사는 원칙적으로 이용자의 개인정보를
				외부에 제공하지 않습니다. 다만, 아래의
				경우는 예외로 합니다.<br />
				o 이용자가 사전에 동의한 경우<br />
				o 회사와 Health&u(헬스앤유) 모바일 플랫폼
				서비스 공급계약을 체결한 디바이스 판매 및
				서비스 이용업체에서 운영유지 및
				판매현황통계가 필요한 경우<br />
				o 서비스 제공에 따른 요금 정산을 위해
				필요한 경우<br />
				o 전기통신기본법, 전기통신사업법 등 관계
				법령의 규정에 의거하거나, 수사목적으로
				법령에 정해진 절차와 방법에 따라
				수사기관의 요구가 있는 경우<br />
				o 통계작성, 학술연구 또는 시장조사를
				위하여 필요한 경우로서 특정 개인을 식별할
				수 없는 형태로 가공하여 제공하는 경우<br />
				<br />
				<b>
					6. 이용자 및 법정대리인의 권리와 그 행사
					방법 </b
				><br />
				① 이용자 및 법정대리인은
				개인정보관리책임자에게 서면, 전화,
				전자우편 등을 통해 개인정보 수집에 대한
				동의를 철회할 수 있으며, 그 경우 회사는
				본인 여부를 확인한 후 법령에 다르게
				규정하고 있는 경우를 제외하고는 당해
				개인정보의 파기 등 필요한 조치를 취합니다.
				단, 회원탈퇴로 인하여 개인정보가 파기되는
				경우에는 해당 이용자가 회사의 서비스를
				이용하면서 생성, 축적한 관련 정보가 함께
				파기될 수 있습니다.<br />
				② 회사는 이용자의 법정대리인이 방문하여
				열람 또는 정정요구를 하는 경우에는
				이용자의 진정한 법정대리인인지 여부를
				확인하며 이 경우 회사는 법정대리관계를
				나타내는 증표를 제시하도록 요구할 수
				있습니다.<br />
				③ 회사는 이용자의 당해 개인정보의 전부
				또는 일부에 대하여 열람 또는 정정요구를
				거절할 정당한 이유가 있는 경우에
				이용자에게 이를 지체 없이 통지하고 그
				이유를 설명합니다.<br />
				<br />
				<b>
					7. 개인정보 자동수집 장치의 설치•운영 및
					그 거부에 관한 사항 </b
				><br />
				① 회사는 이용자에게 특화된 맞춤서비스 등을
				제공하기 위해서 회원의 정보를 수시로
				저장하고 찾아내는 '쿠키(Cookie,
				접속정보파일)'를 운용합니다. 회사는 쿠키
				운용과 관련하여 회원의 컴퓨터 및 휴대폰은
				식별하지만 회원을 개인적으로 식별하지는
				않습니다.<br />
				② 이용자는 '쿠키'에 대한 선택권을 가지고
				있습니다. 이용자는 모바일 기기의 옵션을
				설정 함으로서 모든 쿠키 저장을 허용하거나,
				거부 할 수 있습니다. 단, 모든 쿠키의
				저장을 거부 하는 경우 쿠키를 통해 회사에서
				제공하는 서비스를 이용이 불가능 할 수
				있습니다.<br />
				<br />
				<b
					>8. 개인정보의 기술적/관리적 보호
					대책</b
				><br />
				① 회사는 이용자의 개인정보를 취급함에 있어
				개인정보가 분실, 도난, 누출, 변조 또는
				훼손되지 않도록 안전성 확보를 위해 기술적,
				관리적 대책을 마련하고 있습니다.<br />
				o 기술적 대책<br />
				1) 이용자의 개인정보는 암호화되어 있어
				이용자 본인 외에는 알 수 없으며, 개인정보
				확인 및 변경도 본인의 요청을 통해서만
				가능합니다.<br />
				2) 회사는 암호화 통신을 통하여 네트워크
				상에서 개인정보를 안전하게 전송할 수
				있도록 하고 있습니다.<br />
				3) 회사는 해킹이나 컴퓨터바이러스 등에
				의해 이용자의 개인정보가 유출되거나
				훼손되는 것을 막기 위해 최선을 다하고
				있습니다.<br />
				4) 회사는 만약의 사태를 대비하여
				개인정보를 주기적으로 백업하고 있으며,
				백신프로그램을 이용하여 컴퓨터바이러스에
				의한 피해를 방지하기 위한 조치를 취하고
				있습니다.<br />
				5) 회사는 시스템에 대한 접근통제,
				권한관리, 취약점 점검 등의 조치를 통해
				보안성이 강화될 수 있도록 지속적으로
				노력하고 있습니다.<br />
				o 관리적 대책<br />
				1) 회사는 이용자의 개인정보에 대한
				접근권한을 최소한의 인원으로 제한하고
				있으며, 그 최소한의 인원에 해당하는 자는
				다음과 같습니다.<br />
				A. 이용자를 직접 상대로 하여 마케팅,
				이벤트, 고객지원, 서비스운영, 배송 업무를
				수행하는 자(위탁, 협력 업체의 직원
				포함)<br />
				B. 개인정보관리책임자 등
				개인정보관리업무를 수행하는 자<br />
				C. 기타 업무상 개인정보의 취급이 불가피한
				자<br />
				2) 회사는 개인정보취급자를 대상으로
				개인정보 보호 의무 등에 관해 정기적인
				교육을 실시하고 있습니다.<br />
				3) 회사는 개인정보보호 업무를 전담하는
				부서에서 개인정보취급방침 및 내부 규정
				준수여부를 확인하여 문제가 발견될 경우,
				즉시 바로 잡을 수 있도록 노력하고
				있습니다.<br />
				4) 이용자 본인의 부주의나 인터넷상의
				문제로 이름, 비밀번호 등의 개인정보가
				유출되어 발생한 문제에 대해서는 회사가
				일체 책임을 지지 않습니다.<br />
				<br />
				<b>9. 개인정보에 관한 민원서비스</b><br />
				① 회사는 이용자의 개인정보를 보호하고
				개인정보와 관련한 불만을 처리하기 위하여
				아래와 같이 개인정보관리책임자를 지정하고
				있습니다.<br />
				o 개인정보관리책임자<br />
				§ 소속 : (주)더조인<br />
				§ 전화 : 02-6949-0335<br />
				§ 전자우편 : thejoin@thejoin.co.kr<br />
				② 이용자는 회사의 서비스를 이용하며
				발생하는 모든 개인정보보호 관련 민원을
				개인정보관리책임자에게 신고하실 수
				있습니다. 회사는 이용자의 신고사항에 대해
				신속하게 충분한 답변을 드리도록
				하겠습니다.<br />
				③ 기타 개인정보침해에 대한 신고나 상담이
				필요하신 경우에는 아래 기관에 문의하시기
				바랍니다.<br />
				o 전자거래분쟁조정위원회 (www.ecmc.or.kr /
				1661-5714)<br />
				o 정보보호마크인증위원회
				(www.eprivacy.or.kr / 02-580-0533)<br />
				o 개인정보 침해신고 센터
				(privacy.kisa.or.kr / 02-405-5118)<br />
				o 경찰청 사이버테러대응센터
				(www.ctrc.go.kr / 02-392-0330)<br />
				o 불법청소년유해정보신고 (www.singo.or.kr
				/ 국번 없이 1377)<br />
				<br />
				<b>10. 링크사이트</b><br />
				회사는 이용자에게 다른 회사의 웹사이트
				또는 자료에 대한 링크를 제공할 수
				있습니다. 이 경우 회사는 외부사이트 및
				자료에 대한 아무런 통제권이 없으므로
				그로부터 제공받는 서비스나 자료의 유용성에
				대해 책임질 수 없으며 보증할 수 없습니다.
				회사가 포함하고 있는 링크를 탭(tap)하여 타
				사이트(site)의 페이지로 옮겨갈 경우 해당
				사이트의 개인정보취급방침은 회사와
				무관하므로 새로 방문한 사이트의 정책을
				확인하시기 바랍니다.<br />
				<br />
				<b>11. 기타</b><br />
				본 개인정보취급방침은 법령 정책 또는
				보안기술의 변경에 따라 내용의 추가 삭제 및
				수정이 있을 시에는 변경되는 개인정보
				취급방침을 사전에 홈페이지 통해 변경 이유
				및 내용 등을 공지하도록 하겠습니다.<br />
				시행일자 : 2022년 11월28일<br />
			</p>
		</div>
	</Layout>
</template>

<style lang="scss" scoped>
.wrap {
	width: 100%;
	margin: 140px auto 120px;
	max-width: 1080px;
	text-align: center;
	.clf {
		@include BodyMB($brandL1);
		margin-right: 10px;
	}
	.date {
		@include BodyM($gray5);
	}
	b {
		font-weight: 500;
	}
	h3 {
		padding: 14px 0 48px;
		margin-bottom: 48px;
		@include D3();
		display: block;
		border-bottom: 1px solid #e7e7ef;
	}
	p {
		text-align: left;
		@include BodyM();
	}
}

// 태블릿
@media screen and (max-width: $tabletW) {
	.wrap {
		max-width: 660px;
		h3 {
			padding: 10px 0 40px;
			margin-bottom: 39px;
			@include T3();
		}
	}
}
// 모바일
@media screen and (max-width: $mobileW) {
	.wrap {
		margin: 60px auto 80px;
		padding: 0 20px;
		.clf {
			@include BodySB($brandL1);
		}
		small {
			@include BodyS($gray5);
		}
		h3 {
			padding: 6px 0 24px;
			margin-bottom: 17px;
			@include M3();
		}
		p {
			@include BodyS();
		}
	}
}
</style>
